<script setup lang="ts">
/**
 * PANIER FLOTTANT de la fiche produit (Karim 2026-08-09) — fixé en bas à
 * droite de l'écran. Au niveau du fil d'Ariane il sortait du champ dès qu'on
 * faisait défiler la galerie : sur une fiche produit, l'acheteur ajoute puis
 * veut voir son panier, sans remonter. `z-40` passe au-dessus du contenu mais
 * SOUS le panneau latéral (z-50) qu'il ouvre.
 *
 * ⚠️ `bottom-6` et non `bottom-24` sur mobile : le décalage de 96px visait une
 * « barre d'achat collante » qui N'EXISTE PAS sur la fiche produit — les
 * boutons Acheter / Ajouter y sont dans le flux, pas fixés. Le panier flottait
 * donc au milieu du contenu, par-dessus « Livraison et retrait » (Karim
 * 2026-08-22). `safe-area-inset-bottom` le remonte au-dessus de la barre
 * système des iPhone.
 *
 * Même coin que le chat : il lui réserve sa place (bouton de 2.75rem + 0.75rem
 * d'écart, en plus de la barre système), sinon la mascotte le recouvrait
 * (Karim 2026-10-17).
 */
defineProps<{ totalItems: number }>();

useReserverCoinChat("calc(3.5rem + env(safe-area-inset-bottom))");
</script>

<template>
  <div
    class="fixed right-4 bottom-6 z-40"
    style="bottom: calc(1.5rem + env(safe-area-inset-bottom))"
  >
    <BoutiqueCartButton :total-items="totalItems" class="shadow-lg" />
  </div>
</template>
